/* Dope Star Brand theme scripts */
(function () {
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    if (!format) return '$' + withCommas;
    return format.replace(/\{\{\s*\w+\s*\}\}/, withCommas);
  }

  // Mobile menu + search toggles
  document.querySelectorAll('[data-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-toggle'));
      if (!target) return;
      var open = target.hasAttribute('open');
      if (open) { target.removeAttribute('open'); target.hidden = true; }
      else { target.setAttribute('open', ''); target.hidden = false; var f = target.querySelector('input'); if (f) f.focus(); }
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  // Close desktop dropdowns when another opens / click outside
  var navDetails = document.querySelectorAll('.ds-nav details');
  navDetails.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) navDetails.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
  });
  document.addEventListener('click', function (e) {
    navDetails.forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  // Kick finder
  document.querySelectorAll('[data-finder]').forEach(function (finder) {
    var chips = finder.querySelectorAll('[data-chip]');
    var go = finder.querySelector('[data-finder-go]');
    var label = finder.querySelector('[data-finder-label]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        if (go) go.setAttribute('href', chip.getAttribute('data-url'));
        if (label) label.textContent = chip.getAttribute('data-label');
      });
    });
  });

  // Product page
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var format = root.getAttribute('data-money-format');
    var showSale = root.getAttribute('data-show-sale') === 'true';
    var idInput = root.querySelector('[name="id"]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceNow = root.querySelectorAll('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var save = root.querySelector('[data-save]');
    var mainImg = root.querySelector('.ds-gallery__main img');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        var lbl = fs.querySelector('[data-option-value]');
        if (c && lbl) lbl.textContent = c.value;
        return c ? c.value : null;
      });
    }

    function showMedia(src, id) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-media-id') === String(id))); });
    }

    function markAvailability(opts) {
      root.querySelectorAll('[data-option]').forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return o === test[j]; });
          });
          input.closest('.ds-pill').classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var opts = selected();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      markAvailability(opts);
      if (!variant) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return;
      }
      idInput.value = variant.id;
      priceNow.forEach(function (el) { el.textContent = money(variant.price, format); });
      if (showSale && variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.hidden = false; priceWas.textContent = money(variant.compare_at_price, format);
        if (save) { save.hidden = false; save.textContent = 'You save ' + money(variant.compare_at_price - variant.price, format); }
      } else {
        priceWas.hidden = true; if (save) save.hidden = true;
      }
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_media && variant.featured_media.preview_image) { var s = variant.featured_media.preview_image.src; showMedia(s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=1400', variant.featured_media.id); }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-src'), t.getAttribute('data-media-id')); });
    });
    var qty = root.querySelector('[data-qty]');
    if (qty) {
      root.querySelector('[data-qty-minus]').addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      root.querySelector('[data-qty-plus]').addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }
    markAvailability(selected());
  });

  // Collection sort
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
